<template>
  <main>
    <div
      id="hideinmobile"
      v-if="showBlur"
      class="blur-overlay"
      :class="{ active: isNavOpen }"
    ></div>
    <header
      id="hideinmobile"
      class="position-fixed w-100 font-inter d-flex align-items-center top-0"
      :class="{
        'header-hidden-mobile': showResumeClinic && !loginModalOpen,
        'header-over-modal': showResumeClinic && loginModalOpen,
      }"
    >
      <div class="header-main">
        <b-navbar
          toggleable="lg"
          class="navbar navbar-expand-lg position-relative d-flex align-items-center justify-content-between w-100"
        >
          <section class="d-flex align-items-center navbar-navv">
            <b-navbar-brand @click="checkAndTriggerGoToHome()">
              <img
                class="logo pointer"
                src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
                alt="Hire3x"
              />
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav class="new-classsess">
              <b-navbar-nav class="ml-4 mt-1">
                <b-nav-item-dropdown text="Products" class="">
                  <!-- <b-dropdown-item @click="gotoBuilder">
                    <section class="w-40px">
                      <img
                        class="hover-on-img"
                        src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/cand.svg"
                        alt="Candidate"
                      />
                    </section>
                    <div>
                      <div class="head-1">For Candidates</div>
                      <div class="mt-1 head-2">A Career Growth Platform</div>
                    </div>
                  </b-dropdown-item> -->
                  <b-dropdown-item @click="gotoPanelist">
                    <section class="w-40px">
                      <img
                        class="hover-on-img"
                        src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/panelist-head.svg"
                        alt="Panel"
                      />
                    </section>
                    <div>
                      <div class="head-1">Panelist</div>
                      <div class="mt-1 head-2">Interview, Inspire, Earn</div>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item @click="gotoRecruitment">
                    <section class="w-40px">
                      <img
                        class="hover-on-img"
                        src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/rec.svg"
                        alt="Recruitment"
                      />
                    </section>
                    <div>
                      <div class="head-1">Recruitment</div>
                      <div class="mt-1 head-2">
                        Find Your Ideal Candidate to Hire
                      </div>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item @click="goToInstructor">
                    <section class="w-40px">
                      <img
                        class="hover-on-img"
                        src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/creator-head.svg"
                        alt="Creator"
                      />
                    </section>
                    <div>
                      <div class="head-1">Creator</div>
                      <div class="mt-1 head-2">
                        Get Started as Course Creator
                      </div>
                    </div>
                  </b-dropdown-item>

                  <b-dropdown-item @click="gotoAssessment">
                    <section class="w-40px">
                      <img
                        class="hover-on-img"
                        src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/assess.svg"
                        alt="Assessment"
                      />
                    </section>
                    <div>
                      <div class="head-1">Assessment</div>
                      <div class="mt-1 head-2">
                        Smart and Secure Remote Assessments
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item href="#" class="ms-2" @click="gotoContact('')"
                  >Contact us
                </b-nav-item>
                <b-nav-item href="#" class="ms-2" @click="gotoRequest"
                  >Request a demo</b-nav-item
                >
              </b-navbar-nav>
            </b-collapse>
          </section>
          <b-navbar-nav class="ms-auto d-flex align-items-center gap-16px">
            <!-- Desktop action buttons -->
            <div
              id="hideinmobile"
              class="header-btns d-flex gap-16px align-items-center"
            >
              <div class="pointer" @click="openNotificationPanel()">
                <img
                  src="@/assets/imgs/newhomepage/Icons-bell-not.svg"
                  alt="Notification"
                />
              </div>
              <b-button @click="goToHome()" class="header-for-biz-btn w-170px">
                <img
                  src="../../assets/imgs/newhomepage/forCand.svg"
                  alt="For Business Icon"
                />
                For Candidates
              </b-button>
              <template v-if="isLoggedIn">
                <div class="position-relative user-avatar-container">
                  <div class="user-avatar-btn pointer" @click="toggleUserDropdown">
                    <img v-if="userInfoData && userInfoData.image" :src="userInfoData.image" alt="Avatar" class="user-avatar-img" />
                    <span v-else>{{ (userInfoData && userInfoData.username && userInfoData.username !== 'Unknown') ? (userInfoData.username).charAt(0).toUpperCase() : 'G' }}</span>
                  </div>
                  <transition name="dropdown-fade">
                    <div v-if="userDropdownOpen" class="user-profile-dropdown">
                      <div class="user-profile-banner-wrapper">
                        <div class="user-profile-banner">
                          <div class="banner-avatar">
                            <img v-if="userInfoData && userInfoData.image" :src="userInfoData.image" alt="Avatar" class="user-avatar-img" />
                            <span v-else>{{ (userInfoData && userInfoData.username && userInfoData.username !== 'Unknown') ? (userInfoData.username).charAt(0).toUpperCase() : 'G' }}</span>
                          </div>
                          <span class="banner-username">{{ (userInfoData && userInfoData.username && userInfoData.username !== 'Unknown') ? (userInfoData.username) : 'Guest User' }}</span>
                        </div>
                      </div>
                      <div class="user-dropdown-item" @click="goToDashboard">
                        <img src="../../assets/imgs/newhomepage/mi_home.svg" alt="Home" class="dropdown-icon" />
                        <span>Go to Dashboard</span>
                      </div>
                      <div class="dropdown-divider"></div>
                      <div class="user-dropdown-item logout-item" @click="confirmAndLogout">
                        <img src="../../assets/imgs/newhomepage/Logout.svg" alt="Logout" class="dropdown-icon logout-icon" />
                        <span>Log Out</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </template>
              <b-button
                v-else
                @click="checkAndTriggerLoginModal()"
                class="header-login-btn w-125px"
              >
                Login
                <img src="../../assets/imgs/newhomepage/round-arrow.svg" alt="" />
              </b-button>
            </div>
          </b-navbar-nav>
        </b-navbar>
      </div>
    </header>
    <section id="hideinlaptop"
      :class="{
        'header-hidden-mobile': (showResumeClinic && !loginModalOpen) || loginModalOpen,
        'header-over-modal': showResumeClinic && loginModalOpen,
      }"
    >
      <div class="mobHeader d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-3">
          <div
            class="d-flex"
            v-if="$route.name != 'ResumeClinic'"
            @click="openMobileMenu()"
          >
            <!-- v-if="!showMenuBar" -->
            <img src="../../assets/imgs/newhomepage/hamburger.svg" alt="Menu" />
            <!-- <img
              v-else
              src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/cross.svg"
              alt="Close"
            /> -->
          </div>
          <img
            src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
            alt="Hire3x"
            @click="checkAndTriggerGoToHome(), (showMenuBar = false)"
          />
        </div>
        <!-- <div class="d-flex align-items-center gap-4">
          <span
            v-if="$route.name != 'ResumeClinic'"
            @click="triggerLoginModal()"
            class="color-52A6FF fs-14 fw-700 font-inter"
            >Login</span
          >
          <div
            v-if="$route.name != 'ResumeClinic'"
            @click="showMenuBar = !showMenuBar"
          >
            <img
              v-if="!showMenuBar"
              src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/Menu.svg"
              alt="Sidebar"
            />
            <img
              v-else
              src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/cross.svg"
              alt="Close"
            />
          </div>
        </div> -->
        <Transition name="menu-slide-left">
          <div v-if="showMenuBar" class="menu-bar">
            <div class="drawer-header">
              <div class="d-flex align-items-center gap-2">
                <img
                  @click="handleLogoClick"
                  class="logo"
                  src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
                  alt="Hire3x Logo"
                />
              </div>
              <button class="drawer-close" @click="showMenuBar = false">
                ✕
              </button>
            </div>
            <section class="menu-scroll">
              <div>
                <b-collapse v-model="showMenuOption">
                  <div
                    @click="gotoRecruitment(), (showMenuBar = false)"
                    class="d-flex align-items-center drop-single-option"
                  >
                    <div>
                      <img
                        src="../../assets/imgs/homepage/recruitement.svg"
                        alt="Recruiter"
                      />
                    </div>
                    <div>
                      <h3 class="font-inter fw-500 fs-16 head-trans-txt mb-1">
                        Recruitment
                      </h3>
                      <h4 class="font-manrope color-494949 fs-12 fw-500 mb-0">
                        Find Your Ideal Candidate to Hire
                      </h4>
                    </div>
                  </div>
                  <div
                    @click="gotoAssessment(), (showMenuBar = false)"
                    class="d-flex align-items-center drop-single-option"
                  >
                    <div>
                      <img
                        src="../../assets/imgs/homepage/assessment.svg"
                        alt="Assessment"
                      />
                    </div>
                    <div>
                      <h3 class="font-inter fw-500 fs-16 head-trans-txt mb-1">
                        Assessment
                      </h3>
                      <h4 class="font-manrope color-494949 fs-12 fw-500 mb-0">
                        Smart and Secure Remote Assessments
                      </h4>
                    </div>
                  </div>
                  <div
                    @click="gotoPanelist(), (showMenuBar = false)"
                    class="d-flex align-items-center drop-single-option"
                  >
                    <div>
                      <img
                        src="../../assets/imgs/homepage/panelist.svg"
                        alt="Panel"
                      />
                    </div>
                    <div>
                      <h3 class="font-inter fw-500 fs-16 head-trans-txt mb-1">
                        Panelist
                      </h3>
                      <h4 class="font-manrope color-494949 fs-12 fw-500 mb-0">
                        Interview, Inspire, Earn
                      </h4>
                    </div>
                  </div>
                  <div
                    @click="goToInstructor(), (showMenuBar = false)"
                    class="d-flex align-items-center drop-single-option"
                  >
                    <div>
                      <img
                        src="../../assets/imgs/homepage/creator.svg"
                        alt="Creator"
                      />
                    </div>
                    <div>
                      <h3 class="font-inter fw-500 fs-16 head-trans-txt mb-1">
                        Creator
                      </h3>
                      <h4 class="font-manrope color-494949 fs-12 fw-500 mb-0">
                        Get Started as Course Creator
                      </h4>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <div class="line"></div>
              <div @click="gotoContact('')" class="option">
                <img src="../../assets/imgs/homepage/faq.svg" alt="Creator" />
                FAQ’s
              </div>
              <div @click="gotoContact()" class="option">
                <img
                  src="../../assets/imgs/homepage/contact.svg"
                  alt="Creator"
                />
                Contact us
              </div>
              <div @click="gotoRequest(), (showMenuBar = false)" class="option">
                <img
                  src="../../assets/imgs/homepage/request.svg"
                  alt="Creator"
                />
                Request a demo
              </div>
            </section>

            <footer class="drawer-footer">
              <img
                class="w-100 mb-4"
                @click="goToHome()"
                src="../../assets/imgs/homepage/froCandidates.svg"
                alt=""
              />
              <button
                v-if="!isLoggedIn"
                class="main-blue-btn w-100"
                @click="triggerRegisterModal()"
              >
                Get Started
              </button>
              <button
                class="drawer-logout-btn mt-2"
                @click="checkAndTriggerLoginModal()"
              >
                {{ isLoggedIn ? "Log out" : "Login" }}
              </button>
              <!-- <button class="drawer-logout-btn mt-2">Log out</button> -->
            </footer>
          </div>
        </Transition>
      </div>
    </section>
    <LoginModal :newclass="'bussiness-login'" :userTypeProp="'admin'" />

    <!-- ─── Notification Slide Panel ──────────────────────── -->
    <transition name="notif-slide">
      <div v-if="notifOpen" class="notif-panel">
        <div class="notif-panel-header">
          <span class="notif-panel-title">Notifications</span>
          <button class="notif-close-btn" @click="notifOpen = false">✕</button>
        </div>

        <div class="notif-list">
          <div v-for="(notif, i) in notifications" :key="i" class="notif-card">
            <div
              class="notif-card-body pointer"
              @click="handleNotifAction(notif)"
            >
              <img class="notif-avatar" :src="notif.avatar" :alt="notif.name" />
              <div class="notif-text">
                <p class="notif-name">{{ notif.name }}</p>
                <p class="notif-msg">{{ notif.message }}</p>
                <button
                  v-if="notif.cta"
                  class="notif-cta"
                  @click.stop="handleNotifAction(notif)"
                >
                  {{ notif.cta }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="notifications.length === 0" class="notif-empty">
            You're all caught up! 🎉
          </div>
        </div>
      </div>
    </transition>

    <!-- Overlay to close notification panel -->
    <div
      v-if="notifOpen"
      class="notif-overlay"
      @click="notifOpen = false"
    ></div>
    <div
      v-if="showMenuBar"
      class="notif-overlay-drawer"
      @click="showMenuBar = false"
    ></div>
    <LogoutConfirmModal
      :visible="showLogoutModal"
      @confirm="confirmLogout"
      @cancel="cancelLogout"
    />
    <ResumeClinic
      v-if="showResumeClinic"
      :showModal="showResumeClinic"
      @modalClose="modalClose"
      @openLoginModal="openLoginModal"
      @openLoginModalWithJobID="openLoginModalWithJobID"
    />
  </main>
</template>

<script>
import pageRoute from "@/utils/pageRoute";
import { mapGetters } from "vuex";
import LoginModal from "@/components/commonComponents/LoginModal.vue";
import LogoutConfirmModal from "@/components/modalComponent/LogoutConfirmModal.vue";
import { openLoginModal } from "@/utils/helpers";
import headerMixin from "@/utils/mixins/headerMixin";
import EventBus from "@/utils/eventBus";
import heeraNotificationMixin from "@/utils/mixins/heeraNotificationMixin";
import config from "@/utils/config";
import ResumeClinic from "@/components/modalComponent/ResumeClinic.vue";

export default {
  name: "HeaderPage",
  mixins: [pageRoute, heeraNotificationMixin, headerMixin],
  components: { LoginModal, LogoutConfirmModal, ResumeClinic },
  data() {
    return {
      showMenuBar: false,
      showMenuOption: true,
      isNavOpen: false,
      showBlur: false,
      loginModalOpen: false,
      showLogoutModal: false,
      userDropdownOpen: false,
      showResumeClinic: false,
      config,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "userVUEX/getCandAccess",
      userData: "userVUEX/getUserProfileData",
    }),
    userInfoData() {
      return this.userData || {};
    }
  },
  watch: {
    showMenuBar(val) {
      EventBus.$emit("mobile-menu-state", val);
    },
    userDropdownOpen(val) {
      EventBus.$emit("user-dropdown-toggled", val);
    },
    isNavOpen(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.showBlur = true;
        }, 200);
      } else {
        this.showBlur = false;
      }
    },
  },
  created() {
    EventBus.$on("heera-visited-updated", this.handleHeeraVisitedUpdated);
  },
  mounted() {
    EventBus.$emit("active-header-type", "legacy");
    EventBus.$on("open-login-modal", () => {
      this.loginModalOpen = true;
    });
    this.onLoginModalClosed = () => {
      this.loginModalOpen = false;
    };
    EventBus.$on("close-login-modal", this.onLoginModalClosed);
    this.onResumeClinicOpened = () => {
      this.showResumeClinic = true;
    };
    this.onResumeClinicClosed = () => {
      this.showResumeClinic = false;
    };
    EventBus.$on("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$on("close-resume-clinic", this.onResumeClinicClosed);
    EventBus.$on("resume-clinic-closed", this.onResumeClinicClosed);
    function onClassChange(node, callback) {
      let lastClassString = node.classList.toString();

      const mutationObserver = new MutationObserver((mutationList) => {
        for (const item of mutationList) {
          if (item.attributeName === "class") {
            const classString = node.classList.toString();
            if (classString !== lastClassString) {
              callback(mutationObserver);
              lastClassString = classString;
              break;
            }
          }
        }
      });

      mutationObserver.observe(node, { attributes: true });

      return mutationObserver;
    }

    onClassChange(document.getElementsByClassName("b-nav-dropdown")[0], () => {
      const list = document.getElementsByClassName("b-nav-dropdown");
      if (!list) {
        this.isNavOpen = false;
        return;
      }

      const elem = list[0];

      if (!elem) {
        this.isNavOpen = false;
        return;
      }

      const classes = Array.from(elem.classList);

      if (!classes) {
        this.isNavOpen = false;
        return;
      }

      this.isNavOpen = classes.some((c) => c === "show");
      return;
    });
    this.onWindowFocus = () => {
      this.loadNotifications();
      this.fetchAndUpdateUserProfile();
    };
    window.addEventListener("focus", this.onWindowFocus);
    document.addEventListener("mousedown", this.handleDocumentClick, true);
    
    // Sync profile data on initial mount in case localStorage has stale data
    this.fetchAndUpdateUserProfile();
  },
  beforeDestroy() {
    EventBus.$off("mobile-menu-state");
    EventBus.$off("open-login-modal");
    EventBus.$off("close-login-modal", this.onLoginModalClosed);
    EventBus.$off("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$off("close-resume-clinic", this.onResumeClinicClosed);
    EventBus.$off("resume-clinic-closed", this.onResumeClinicClosed);
    document.body.style.overflow = "";
    window.removeEventListener("focus", this.onWindowFocus);
    document.removeEventListener("mousedown", this.handleDocumentClick, true);
    EventBus.$off("heera-visited-updated", this.handleHeeraVisitedUpdated);
  },
  methods: {
    handleDocumentClick(event) {
      if (this.userDropdownOpen) {
        const userAvatar = this.$el.querySelector('.user-avatar-container');
        if (userAvatar && !userAvatar.contains(event.target)) {
          this.closeUserDropdown();
        }
      }
    },
    toggleUserDropdown() {
      this.userDropdownOpen = !this.userDropdownOpen;
    },
    closeUserDropdown() {
      this.userDropdownOpen = false;
    },
    confirmAndLogout() {
      this.userDropdownOpen = false;
      this.showLogoutModal = true;
      EventBus.$emit("logout-modal-opened");
    },
    openNotificationPanel() {
      this.notifOpen = true;
    },
    handleLogoClick() {
      if (this.loginModalOpen) {
        EventBus.$emit("close-login-modal");
      }
      this.showResumeClinic = false;
      EventBus.$emit("close-resume-clinic");
      EventBus.$emit("logo-clicked");

      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.showMenuBar = false;
    },
    checkAndTriggerLoginModal() {
      if (this.isLoggedIn) {
        this.showLogoutModal = true;
        EventBus.$emit("logout-modal-opened");
      } else {
        this.triggerLoginModal();
      }
    },
    async confirmLogout() {
      await this.$store.dispatch("userVUEX/LogOut");
      this.showLogoutModal = false;
      this.showMenuBar = false;
      EventBus.$emit("logout-modal-closed");
    },
    cancelLogout() {
      this.showLogoutModal = false;
      EventBus.$emit("logout-modal-closed");
    },
    checkAndTriggerGoToHome() {
      this.showResumeClinic = false;
      EventBus.$emit("close-resume-clinic");
      EventBus.$emit("logo-clicked");

      if (this.loginModalOpen) {
        console.log("Execwifnjf");
        EventBus.$emit("close-login-modal");
        this.goToAdminHome();
        return;
      }

      let isScrolledUp = window.scrollY === 0;
      const homeContainer = document.getElementById("home-container");
      if (homeContainer) {
        isScrolledUp = isScrolledUp && homeContainer.scrollTop === 0;
      }

      if (this.$route.name === "HomePage" && isScrolledUp) {
        this.$router.push({ name: "NewHomePage" });
        return;
      }

      this.goToAdminHome();
    },
    openMobileMenu() {
      if (this.showMenuBar) {
        this.showMenuBar = false;
        return;
      }

      if (this.notifOpen) {
        this.notifOpen = false;
      }

      if (this.loginModalOpen) {
        EventBus.$emit("close-login-modal");
      }
      this.showMenuBar = true;
    },
    goToHome() {
      this.$router.push({
        name: "NewHomePage",
      });
    },
    triggerLoginModal() {
      if (this.showMenuBar) {
        this.showMenuBar = false;
      }
      openLoginModal({ userType: "admin" });
    },
    openLoginModal(uuid) {
      this.$store.commit("userVUEX/setresumeClinicuid", uuid);
      openLoginModal({ /* hideBusiness: true */ });
    },
    openLoginModalWithJobID(jobId, uuid) {
      this.$store.commit("userVUEX/setresumeClinicuid", uuid);
      this.$store.commit("userVUEX/setresumeJobid", jobId);
      openLoginModal({ /* hideBusiness: true */ });
    },
    modalClose() {
      this.showResumeClinic = false;
    },
    triggerRegisterModal() {
      if (this.showMenuBar) {
        this.showMenuBar = false;
      }
      openLoginModal({ mode: "register" });
    },
  },
};
</script>

<style>
@media (max-width: 1027px) {
  .header-hidden-mobile {
    display: none !important;
  }
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  background-image: url("../../assets/imgs/homepage/grey-down-arrow.svg") !important;
  background-repeat: no-repeat;
  content: "";
  border-top: unset !important;
  border-right: unset !important;
  border-bottom: unset !important;
  border-left: unset !important;
  width: 10px;
  margin-top: 3px;
  height: 7px;
  margin-left: 10px !important;
  transition: transform 0.3s ease-in-out;
}
.show .dropdown-toggle::after {
  transform: rotate(180deg);
}
.mobHeader {
  padding: 10px 30px;
  height: 72px;
  background: #ffffff;
  /* box-shadow: 0px 4px 20px #000000; */
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1101;
}
header {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  backdrop-filter: blur(50px);
  height: 72px;
  z-index: 50;
  padding: 0px 30px;
}

.header-main {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}

.navbar {
  z-index: 9;
  padding: 0px !important;
}

.nav-tabs {
  padding: 0.5rem;
  background: #e5f0ff;
  max-width: max-content;
  border-radius: 12px;
}

.nav-tabs .nav-item .nav-link.active {
  border-radius: 6px;
}

.nav-tabs .nav-link {
  background: unset;
  text-transform: uppercase;
  font-size: 0.875rem;
}

.nav-tabs .nav-item .nav-link.active {
  border-radius: 8px;
  border: 0;
  background: #5186bd;
  color: #fff;
  font-size: 85%;
}

.navbar-navv .nav-link {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #71839b !important;
}

.login-text .nav-link {
  font-family: "Inter", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #52a6ff !important;
}

.mainbtn .nav-link {
  color: #fff !important;
}

.menu-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 90%;
  max-width: 380px;
  height: 100dvh;
  background: #ffffff;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}
.menu-bar .line {
  height: 1px;
  width: 100%;
  background-color: #f1f1f1;
}
.menu-bar .option {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  padding: 10px 16px;
  display: flex;
  gap: 12px;
}
.head-trans-txt {
  color: #000000;
}
.drop-single-option {
  padding: 12px 16px;
  gap: 12px;
}
.drop-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}
.drop-option-sel {
  background-color: #2e425d;
  color: #f6f9fc !important;
  border-radius: 0px 0px 4px 4px;
}
.menu-pos {
  bottom: 38px;
}
.menu-scroll {
  flex: 1;
  overflow-y: auto;
  height: auto;
}
.menu-slide-left-leave-active,
.menu-slide-left-enter-active {
  transition: 0.5s;
}

.menu-slide-left-enter,
.menu-slide-left-enter-from {
  transform: translate(-100%, 0);
}

.menu-slide-left-leave-to {
  transform: translate(-100%, 0);
}

.dropdown-menu {
  width: 343px;
  left: -5px !important;
  border-radius: 0px 0px 16px 16px !important;
  padding: 0px !important;
  margin: 0px !important;
  border: unset !important;
}

.dropdown-item {
  padding: 15px 20px !important;
  display: flex !important;
  gap: 10px !important;
  align-items: center !important;
  border-radius: 16px;
}

.dropdown-item:hover {
  background-color: #52a6ff !important;
}

.head-1 {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.03em;
  background: linear-gradient(179.21deg, #102133 0.68%, #4c78ce 165.08%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  backdrop-filter: blur(2px);
}

.head-2 {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #333333;
}

.dropdown-item:hover .head-1 {
  background: none; /* Remove gradient */
  -webkit-background-clip: unset;
  -webkit-text-fill-color: unset;
  background-clip: unset;
  text-fill-color: unset;
  color: #253f69 !important;
}

.dropdown-item:hover .head-2 {
  color: #253f69 !important;
}

.dropdown-item:hover img {
  background: #fff !important;
  border-radius: 50% !important;
}

.new-classsess .nav-link:hover {
  color: #1b3755 !important;
  box-shadow: inset 0 -3px #1b3755 !important;
}

.navbar-expand-lg .navbar-nav .nav-item:not(.btn-login) .nav-link {
  padding: 23px 20px;
  display: flex;
  align-items: center;
}
.navbar-expand-lg .navbar-nav .dropdown-menu {
  position: absolute;
  padding: 15px !important;
  width: 738px;
  background-color: #ffffff;

  display: none;
}

.dropdown-menu.show {
  display: flex !important;
  flex-wrap: wrap;
}
.navbar-expand-lg .navbar-nav .dropdown-menu li {
  width: 50%;
}
.dropdown-item:hover {
  background-color: #d0e2ff !important;
}

.blur-overlay {
  height: calc(100vh - 72px);
  width: 100%;
  position: fixed;
  top: 72px;
  z-index: 30;
  backdrop-filter: blur(0px); /* Initially no blur */
  background: rgba(0, 0, 0, 0); /* Initially transparent */
  opacity: 0;
  transition: backdrop-filter 0.5s ease-in-out, opacity 0.5s ease-in-out,
    background 0.5s ease-in-out;
}

.blur-overlay.active {
  backdrop-filter: blur(5px); /* Apply blur smoothly */
  background: rgba(0, 0, 0, 0.3); /* Subtle dark overlay */
  opacity: 1;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #efefef;
}

.drawer-header .logo {
  height: 23px;
}
.drawer-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #4a7eff;
  cursor: pointer;
  padding: 0;
}

@media screen and (max-width: 1028px) {
  .mobHeader {
    padding: 10px 32px 10px 26px;
  }
  .notif-overlay-drawer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1028;
  }
  .drawer-logout-btn {
    width: 100%;
    padding: 12px;
    border-radius: 25px;
    border: 1px solid #4A7EFF;
    background: #ffffff;
    color: #4A7EFF;
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .drawer-logout-btn:hover {
    background: #4A7EFF;
    color: #ffffff;
  }
  .drawer-footer {
    padding: 20px 24px;
  }
}
.w-170px {
  width: 170px !important;
}
.w-125px {
  width: 125px !important;
}
.gap-16px {
  gap: 16px !important;
}
</style>
